import { GeneralCode } from "models/content/GeneralCode";

export enum SettingType {
    String = "string",
    Number = "number",
    Boolean = "bool",
	BoolInfo = "boolinfo",
	Link = "link",
    Minutes = "minutes",
	Hours = "hours",
    MTokens = "mtokens",
	Currency = "currency",
	Percent = "percent",
	Time = "time",
	Date = "date",
	DateTime = "datetime",
	Color = "color",
	Image = "image",
	File = "file",
	Interval = "interval",
	
	
}

export class Setting {
    id?:string;
	brandId: number;

	paramName: string;

	
	paramValue: any;

	
	paramType?: SettingType;

	
	forClient?: boolean;

	
	description: string;

	
	prevalidatedParamValue: string;

	
	position?: any;

	
	belongs?: string;

	category?: GeneralCode;	

	categoryId?: number;
}
